import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appendTestId',
  standalone: true,
})
export class AppendTestIdPipe implements PipeTransform {
  transform(
    value: string,
    suffix: string | number,
    separator: string = '-'
  ): string {
    return `${value}${separator}${suffix}`;
  }
}
